export class CmsError extends Error {
  constructor(msg: string) {
    super(msg)
    this.name = "cms"
  }
}
